import React from 'react';
import { PropTypes } from 'prop-types';
// logic
import { push } from 'connected-react-router';
import routes from 'utils/routes';
import { useTranslation } from 'react-i18next';
// state
import { useDispatch } from 'react-redux';
// styles
import styled from 'styled-components';
// components
import { actions as ordersActions } from 'state/orders';
import Tabs from 'refactored/ui/nav/appBar/tabs';
import { IS_TENANT } from 'tenant/utils';

const OrdersTabs = ({ className, location }) => {
  const dispatch = useDispatch();
  const pathname = location.pathname;

  const { t } = useTranslation('Orders');

  const navigateTo = (path) => {
    if (pathname === path) return;
    dispatch(ordersActions.resetData());
    dispatch(push(path));
  };

  const options = [
    {
      label: t('active'),
      value: routes.orders.active,
      onClick: () => {
        navigateTo(routes.orders.active);
      },
    },
    {
      label: t('previous'),
      value: routes.orders.previous,
      onClick: () => {
        navigateTo(routes.orders.previous);
      },
    },
  ];

  if (!IS_TENANT) {
    options.push({
      label: t('recurring'),
      value: routes.orders.recurring,
      onClick: () => {
        navigateTo(routes.orders.recurring);
      },
    });
  }

  return (
    <div className={className}>
      <Tabs options={options} value={pathname} />
    </div>
  );
};

OrdersTabs.propTypes = {
  className: PropTypes.string,
  location: PropTypes.any.isRequired,
};

export default styled(OrdersTabs)`
  background-color: var(--white);
  border-bottom: 1px solid var(--grey200);
`;
